<template>
  <div class="modal-container clearfix">
    <div class="add-box clearfix">
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="480"
          :auto-resize="true"
          align="center"
          :data="tableData"
          :edit-rules="tableRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
      >
        <vxe-table-column width="55" align="center">
          <template v-slot:header>
            <Button class="add-btn" icon="md-add" @click="insertEvent"></Button>
          </template>
          <template v-slot="{ row,$rowIndex }">
            <Button class="del-btn" icon="md-remove" @click="removeEvent(row,$rowIndex)"></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="shipName" title="船名" width="90">
          <template v-slot:header>
            <span style="color: red">*</span>船名
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipName" placeholder="必填" @blur="clearTableV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="mmsi" title="MMSI" width="90">
          <template v-slot:header>
            <span style="color: red">*</span>MMSI
          </template>
          <template v-slot="{row}">
            <vxe-input v-model="row.mmsi" placeholder="必填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="deadweight" title="载重吨" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.deadweight" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="homePort" title="船籍港" width="220">
          <template v-slot="scope">
            <Cascader class="cascader" style="width: 200px" v-model="scope.row.homePort" :data="home_port"
                      trigger="click" change-on-select :render-format="(file)=> format(file,scope.row)"
                      transfer></Cascader>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipType" title="船舶种类" width="120">
          <template v-slot="scope">
            <vxe-select v-model="scope.row.shipType" transfer>
              <vxe-option v-for="(item,index) in ship_type" :key="index" :value="item.label"
                          :label="item.label"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipLength" title="船长(m)" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipLength" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipWidth" title="船宽(m)" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipWidth" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="totalweight" title="总吨" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.totalweight" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="netweight" title="净吨" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.netweight" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="loadDraught" title="满载吃水(m)" width="140">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.loadDraught" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="depth" title="型深" width="140">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.depth" placeholder="选填"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buildTime" title="建造时间" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.buildTime" type="date" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipOwner" title="船舶所有人" width="140">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipOwner" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipOperator" title="船舶经营人" width="140">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipOperator" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="linkMan" title="船舶联系人" width="140">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipLinkList[0].linkMan" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="linkPhone" title="船舶联系方式" width="140">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.shipLinkList[0].linkPhone" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="license" title="营运证所有人" width="150">-->
        <!--          <template v-slot="{ row }">-->
        <!--            <upload-list :row="row.license" :maxLength="10" :initFileList="row.licenseList"-->
        <!--                         :view="'packup'"></upload-list>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <!--        <vxe-table-column field="licenseTon" title="营运证吨位" width="150">-->
        <!--          <template v-slot="{ row }">-->
        <!--            <upload-list :row="row.licenseTon" :maxLength="10" :initFileList="row.licenseTonList"-->
        <!--                         :view="'packup'"></upload-list>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <!--        <vxe-table-column field="owner" title="船舶所有权" width="150">-->
        <!--          <template v-slot="{ row }">-->
        <!--            <upload-list :row="row.owner" :maxLength="10" :initFileList="row.ownerList" :view="'packup'"></upload-list>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <!--        <vxe-table-column field="shipNation" title="船舶国籍证书" width="150">-->
        <!--          <template v-slot="{ row }">-->
        <!--            <upload-list :row="row.shipNation" :maxLength="10" :initFileList="row.shipNationList"-->
        <!--                         :view="'packup'"></upload-list>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <!--        <vxe-table-column field="orther" title="其他证件" width="150">-->
        <!--          <template v-slot="{ row }">-->
        <!--            <upload-list :row="row.orther" :maxLength="10" :initFileList="row.ortherList"-->
        <!--                         :view="'packup'"></upload-list>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button type="primary" @click="impotEvent">上传导入文件</Button>
      <Button type="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage" @cover="cover" :conImport="true"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import $api from '@/apiProvider';
import XLSX from "xlsx";
import Message from "@/components/common/Message";
import {getExcelTime, showLoading, hideLoading} from '@/utils/util'
import UploadList from '@/components/common/UploadList'

export default {
  components: {Message},
  data() {
    return {
      tableData: [{
        no: 1,
        buildTime: null,
        deadweight: null,
        homePort: [],
        loadDraught: null,
        depth: null,
        mmsi: null,
        netweight: null,
        shipLength: null,
        shipName: '',
        shipType: null,
        shipWidth: null,
        totalweight: null,
        shipOwner: null,
        shipOperator: null,
        licenseList: [],
        licenseTonList: [],
        shipNationList: [],
        ownerList: [],
        ortherList: [],
        shipLinkList: [{
          linkMan: null,
          linkPhone: null,
        }],
        licenseUuidList: [],
        licenseTonUuidList: [],
        shipNationUuidList: [],
        ownerUuidList: [],
        ortherUuidList: [],
        license: {fileUuidList: []},
        licenseTon: {fileUuidList: []},
        shipNation: {fileUuidList: []},
        owner: {fileUuidList: []},
        orther: {fileUuidList: []}
      }],
      tableRules: {
        mmsi: [
          {required: true, message: "请输入MMSI"},
          {min: 9, max: 9, message: '请输入9位数字'}
        ],
        shipName: [
          {required: true, message: "请输入船名"},
        ],
      },
      messageVisible: false,
      message: '',
      ship_type: [],
      home_port: [],
      coverData: [],
      dict: [],
      homePort: [],
      isImport: false
    }
  },
  mounted() {
    this.getDictByCode(40600, 'ship_type');
    this.getDict();
    this.getHomePort();
  },
  methods: {
    format(labels, row) {
      if (labels.length === 1) {
        if (!this.isImport) {
          row.homePort = [];
          this.$Message.error('请选择至少两级船籍港');
        }
        return '';
      } else {
        const index = labels.length - 1;
        return labels[index];
      }
    },
    async getHomePort() {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList');
      hideLoading();
      if (res.code === 1) {
        this.homePort = res.data;
        let province = [];
        res.data.map(i => {
          if (i.cityCodeP === '0') {
            province.push({
              label: i.cityText,
              value: i.cityCode,
              children: []
            })
          }
        })
        province.map(i => {
          res.data.map(j => {
            if (i.value === j.cityCodeP) {
              i.children.push({
                label: j.cityText,
                value: j.cityCode,
                children: []
              })
            }
          })
        })
        province.map(i => {
          i.children.map(j => {
            res.data.map(k => {
              if (j.value === k.cityCodeP) {
                j.children.push({
                  label: k.cityText,
                  value: k.cityCode,
                })
              }
            })
          })
        })

        this.home_port = province;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    closeMessage() {
      this.messageVisible = false;
    },
    impotEvent() {
      this.isImport = true;
      let that = this;
      this.$refs.xTable.readFile({
        types: ['xls', 'xlsx']
      }).then(evnt => {
        showLoading();
        const tableData = [];
        const files = evnt.target.files;
        const fileReader = new FileReader();
        fileReader.onload = (ev) => {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {type: 'binary'});
          const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
          // 解析数据
          let xlsxData = csvData.split('\n');
          //删除xlsx列名
          xlsxData.splice(0, 1);
          xlsxData.forEach((vRow) => {
            if (vRow) {
              const vCols = vRow.split(',');
              let homePort = vCols[4];
              let arr = [];
              if (homePort && homePort !== '') {
                let city1 = this.homePort.filter(i => i.cityText === homePort);
                if (city1.length > 0 && city1[0].cityCodeP !== '0') {
                  let city2 = this.homePort.filter(i => i.cityCode === city1[0].cityCodeP);
                  if (city2.length > 0 && city2[0].cityCodeP !== '0') {
                    let city3 = this.homePort.filter(i => i.cityCode === city2[0].cityCodeP);
                    arr = [city3[0].cityCode, city2[0].cityCode, city1[0].cityCode];
                  } else {
                    arr = [city2[0].cityCode, city1[0].cityCode];
                  }
                }
              }
              const item = {
                no: vCols[0],
                shipName: vCols[1],
                mmsi: vCols[2],
                deadweight: vCols[3],
                homePort: arr,
                shipType: vCols[5],
                shipLength: vCols[6],
                shipWidth: vCols[7],
                totalweight: vCols[8],
                netweight: vCols[9],
                loadDraught: vCols[10],
                depth: vCols[11],
                buildTime: getExcelTime(vCols[12]),
                shipOwner: vCols[13],
                shipOperator: vCols[14],
                shipLinkList: [{
                  linkMan: vCols[15],
                  linkPhone: vCols[16],
                }],
                licenseList: [],
                licenseTonList: [],
                shipNationList: [],
                ownerList: [],
                ortherList: [],
                licenseUuidList: [],
                licenseTonUuidList: [],
                shipNationUuidList: [],
                ownerUuidList: [],
                ortherUuidList: [],
                license: {fileUuidList: []},
                licenseTon: {fileUuidList: []},
                shipNation: {fileUuidList: []},
                owner: {fileUuidList: []},
                orther: {fileUuidList: []}
              };
              tableData.push(item);
            }
          })
          this.tableData = tableData;
        }
        fileReader.readAsBinaryString(files[0]);
        setTimeout(() => {
          hideLoading();
          that.isImport = false;
        }, 1000);
      })
    },
    async insertEvent() {
      let record = {
        no: this.$refs.xTable.data.length + 1,
        buildTime: null,
        deadweight: null,
        homePort: [],
        loadDraught: null,
        depth: null,
        mmsi: null,
        netweight: null,
        shipLength: null,
        shipName: '',
        shipType: null,
        shipWidth: null,
        totalweight: null,
        shipOwner: null,
        shipOperator: null,
        shipLinkList: [{
          linkMan: null,
          linkPhone: null,
        }],
        licenseList: [],
        licenseTonList: [],
        shipNationList: [],
        ownerList: [],
        ortherList: [],
        licenseUuidList: [],
        licenseTonUuidList: [],
        shipNationUuidList: [],
        ownerUuidList: [],
        ortherUuidList: [],
        license: {fileUuidList: []},
        licenseTon: {fileUuidList: []},
        shipNation: {fileUuidList: []},
        owner: {fileUuidList: []},
        orther: {fileUuidList: []}
      };
      let {row: newRow} = await this.$refs.xTable.insertAt(record, -1);
      this.$refs.xTable.data.push(record);
      await this.$refs.xTable.setActiveCell(newRow, "shipName");
    },
    async validEvent() {
      let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    removeEvent(row, i) {
      if (this.$refs.xTable.tableData.length > 1) {
        this.$XModal.confirm("您确定要删除该数据?").then((type) => {
          if (type === "confirm") {
            this.$refs.xTable.remove(row);
            this.$refs.xTable.data.splice(i, 1);
          }
        });
      } else {
        this.$XModal.alert({
          message: "已经是最后一条了！",
          status: "warning",
        });
      }
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    async commit() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return
      }
      this.save();
    },
    async save() {
      let arr = JSON.parse(JSON.stringify(this.tableData));
      arr.map(i => {
        if (i.shipName) {
          i.shipName = i.shipName.trim();
        }
        if (i.mmsi) {
          i.mmsi = i.mmsi.trim();
        }
        i.homePort = i.homePort.toString();
        i.licenseUuidList = i.license.fileUuidList;
        i.licenseTonUuidList = i.licenseTon.fileUuidList;
        i.shipNationUuidList = i.shipNation.fileUuidList;
        i.ownerUuidList = i.owner.fileUuidList;
        i.ortherUuidList = i.orther.fileUuidList;
        if (i.buildTime) {
          i.buildTime = this.$utils.timestamp(i.buildTime);
        }
        i.deadweight = i.deadweight ? parseFloat(i.deadweight) : '';
        i.loadDraught = i.loadDraught ? parseFloat(i.loadDraught) : '';
        i.depth = i.depth ? parseFloat(i.depth) : '';
        i.netweight = i.netweight ? parseFloat(i.netweight) : '';
        i.shipLength = i.shipLength ? parseFloat(i.shipLength) : '';
        i.shipWidth = i.shipWidth ? parseFloat(i.shipWidth) : '';
        i.totalweight = i.totalweight ? parseFloat(i.totalweight) : '';
      })
      showLoading();
      let res = await $api.carShip.request('createShip', arr);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.close();
        this.$emit('afterSave');
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + '序号' + (this.tableData[i.failArrayIndex].no) + '，' + i.failMsg + '\n';
          })
          let errorData = []
          let coverData = [];
          res.data.forEach(failItem => {
            errorData.push(Object.assign({}, this.tableData[failItem.failArrayIndex]));
            coverData.push(failItem.vo);
          })
          this.tableData = errorData;
          this.coverData = coverData;
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    cover() {
      this.$XModal.confirm('确认继续导入，将更新原有数据！').then(type => {
        if (type === 'confirm') {
          this.coverImport();
        }
      })
    },
    async coverImport() {
      showLoading();
      let res = await $api.carShip.request('coverShip', this.coverData);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('更新成功');
        this.messageVisible = false;
        this.close();
        this.$emit('afterSave', 'afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.tableData = [{
        no: 1,
        buildTime: null,
        deadweight: null,
        homePort: [],
        loadDraught: null,
        depth: null,
        mmsi: null,
        netweight: null,
        shipLength: null,
        shipName: '',
        shipType: null,
        shipWidth: null,
        totalweight: null,
        shipOwner: null,
        shipOperator: null,
        licenseList: [],
        licenseTonList: [],
        shipNationList: [],
        ownerList: [],
        ortherList: [],
        shipLinkList: [{
          linkMan: null,
          linkPhone: null,
        }],
        licenseUuidList: [],
        licenseTonUuidList: [],
        shipNationUuidList: [],
        ownerUuidList: [],
        ortherUuidList: [],
        license: {fileUuidList: []},
        licenseTon: {fileUuidList: []},
        shipNation: {fileUuidList: []},
        owner: {fileUuidList: []},
        orther: {fileUuidList: []}
      }];
      this.coverData = [];
    }
  }
}
</script>

<style scoped>
.cascader >>> .ivu-cascader-arrow {
  position: absolute;
  top: 50% !important;
  right: 8px !important;
  line-height: 1;
  transform: translateY(-50%);
  font-size: 14px;
  color: #808695;
  transition: all .2s ease-in-out;
}
</style>